module.exports = __webpack_public_path__ + "static/pod-belong-active-6f72e616b66432d88a466e9b283d149d.jpg";